import Forbidden from "@/views/403.vue";
import NotFound from "@/views/404.vue";
import foreign from "@/views/foreign.vue";

export const constantRouterMap = [
  {
    path: "/user",
    component: () => {
      return import(/* webpackChunkName: "user" */ "@/layouts/UserLayout");
    },
    redirect: "/user/login",
    hideInMenu: true,
    children: [
      {
        path: "login",
        name: "login",
        component: () =>
          import(/* webpackChunkName: "user" */ "@/views/User/Login")
      }
    ]
  },
  {
    path: "/403",
    name: "403",
    hideInMenu: true,
    component: Forbidden
  },
  {
    path: "/404",
    name: "404",
    hideInMenu: true,
    component: NotFound
  },
  {
    path: "/foreign",
    name: "foreign",
    hideInMenu: true,
    component: foreign
  }
];
